import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Row, Col, Button } from 'react-bootstrap';

import { removeVoucher, getVoucherDiscountValue } from '../../VoucherActions.js';
import { getCartTotals } from '../../../Cart/CartHelpers.js';
import { getLoggedUser, getUserOption } from '../../../User/UserActions.js';
import { getTranslation } from '../../../Intl/IntlHelper.js';

import Icon from '../../../../components/Content/Icon.js';
import Price from '../../../Currency/components/view/Price.js';

function VoucherLineView({ dispatch, voucher, order, cart, user, cartTotals, intl }) {
    const handleRemoveVoucher = () => {
        dispatch(removeVoucher(voucher.code));
    };

    const renderActionValue = action => {
        switch(action.key) {
            case 'product':
                return <FormattedMessage id="free" defaultMessage="Free" key={action.key} />;

            case 'conditionRemover':
                return null;

            default: {
                // let { value } = action;
                // if(action.type === 'percentage') {
                //     const baseValue = action.key === 'subtotal' ? totals.items : totals.shippingFee;
                //     value = formatPrice((baseValue * action.value) / 100);
                // }
                const value = getVoucherDiscountValue(voucher, (order || cart || {}).items, ((order || {}).totals || cartTotals || {}).shippingFee || 0, { exemptVAT: getUserOption((order || {}).user || user, 'exemptVAT') });
                return <span key={action.key}>-<Price amount={value} /></span>;
            }
        }
    };

    if(voucher) {
        return (
            <Row>
                <Col xs="6" className="text-end">
                    <Button variant="link" size="sm" onClick={event => { event.preventDefault(); handleRemoveVoucher(); }}><Icon icon="trash" /></Button>{' '}
                    {getTranslation(voucher, 'name', intl.locale)}:{' '}
                </Col>
                <Col xs="6" md={{}}>
                    <span className="d-inline-block h5 mb-0 text-success">
                        {voucher.actions.map((action, index) => <div key={index}>{renderActionValue(action)}</div>)}
                    </span>
                </Col>
            </Row>
        );
    }
}

function mapStateToProps(store, props) {
    const user = getLoggedUser(store);
    return {
        user,
        cartTotals: getCartTotals(store, props.order ? props.order.user : user),
    };
}

VoucherLineView.defaultProps = {
    user: {},
    cart: {},
    order: null,
    cartTotals: {},
};

VoucherLineView.propTypes = {
    dispatch: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    voucher: PropTypes.object.isRequired,
    user: PropTypes.object,
    order: PropTypes.object,
    cart: PropTypes.object,
    cartTotals: PropTypes.object
};

export default connect(mapStateToProps)(injectIntl(VoucherLineView));
